import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "p-breadcrumb p-component"
}
const _hoisted_2 = { class: "p-breadcrumb-list" }
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-menuitem-separator",
  style: {"margin":"0 0.5rem 0 0.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "pi pi-chevron-right",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (breadcrumb, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "p-menuitem",
          key: breadcrumb.name
        }, [
          (index < _ctx.breadcrumbs.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_router_link, {
                  class: "p-menuitem-link",
                  to: { name: breadcrumb.name }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc(breadcrumb.label, 2)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _hoisted_4
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$tc(breadcrumb.label, 2)), 1))
        ]))
      }), 128))
    ])
  ]))
}